import type { ScanServiceType, SelectedFiles } from '@witmetrics/utils';
import { isEmpty } from '@witmetrics/utils/misc';
import { isNightguardService } from '@witmetrics/utils/scanServices';

export const classes = {
  step: 'h-full min-h-0 overflow-auto',
  stepper: 'pt-6 h-full flex flex-col',
  stepperBody: 'h-full grow min-h-0 overflow-hidden',
};

export function isMissingScans(
  serviceType: ScanServiceType | undefined,
  selectedFiles: SelectedFiles
) {
  if (!serviceType) return false; // Non-AI cases have no file requirements
  return !(isNightguardService(serviceType)
    ? hasBothArches(selectedFiles)
    : hasArch(selectedFiles));
}

function hasBothArches(selectedFiles: SelectedFiles) {
  // Has both arches selected (required for Michigan splint / nightguard services)
  return !(
    isEmpty(selectedFiles.RELU_UPPER_ARCH) ||
    isEmpty(selectedFiles.RELU_LOWER_ARCH)
  );
}

function hasArch(selectedFiles: SelectedFiles) {
  // Has at least one arch selected for other services
  return !(
    isEmpty(selectedFiles.RELU_UPPER_ARCH) &&
    isEmpty(selectedFiles.RELU_LOWER_ARCH)
  );
}
